<template>
    <section aria-labelledby="rebrand-heading" class="border-b border-glass-border px-4 pt-32 pb-16 md:pt-36 md:pb-20">
        <article class="mx-auto max-w-4xl">
            <img src="/images/possentra-logo.png" alt="" width="72" height="72" class="mb-6 h-18 w-18 object-contain" />
            <h2 id="rebrand-heading" class="mb-8 text-3xl leading-tight font-bold text-foreground md:text-5xl">
                DigitalSafe is becoming Possentra — a new name for a broader vision
            </h2>
            <div class="space-y-6 text-lg leading-relaxed text-muted-foreground">
                <p>
                    DigitalSafe began with an idea: helping people create a digital record of the physical assets that matter to them.
                    As we developed that concept, our vision grew beyond banknotes to include personal belongings, documents, coins and collections.
                </p>
                <p>To reflect this broader direction, we are introducing <strong class="text-foreground">Possentra</strong>.</p>

                <h3 class="pt-4 text-2xl font-semibold text-foreground">What we are building</h3>
                <p>
                    Possentra is being developed to bring photographs, identifying details, supporting documents and an item’s recorded history together in one place.
                </p>
                <p>
                    At the heart of the platform is <strong class="text-foreground">POSS ID</strong> — an identifier designed to connect a physical asset’s digital record with its documentation and history.
                </p>
                <p>Our planned workflow is simple:</p>
                <p class="rounded-xl border border-primary/20 bg-primary/5 p-5 font-semibold text-foreground">
                    Register an item → Create its POSS ID → Generate a digital passport → Share selected information for verification
                </p>
                <p>
                    Whether you are documenting a watch, organising a collection or keeping service records for equipment, our goal is to make that information easier to manage and share.
                </p>

                <h3 class="pt-4 text-2xl font-semibold text-foreground">Where blockchain fits</h3>
                <p>
                    We plan to use cryptographic verification and blockchain to help detect changes to recorded information and support a verifiable history.
                    A digital record does not, by itself, prove that a physical item is authentic or establish legal ownership.
                </p>

                <h3 class="pt-4 text-2xl font-semibold text-foreground">What the change means</h3>
                <p>
                    Possentra is the continuation and expansion of DigitalSafe.
                    The new name brings our work on identification, digital passports and record verification under one brand.
                </p>
                <p>
                    The project remains in development. We will share progress, demonstrations and details of the first release as they become available.
                </p>
                <p>Thank you for following the project as it takes its next step.</p>
                <div class="space-y-3 border-t border-glass-border pt-6">
                    <p>
                        <strong class="text-foreground">Discover Possentra:</strong>
                        <a href="https://possentra.com" class="ml-2 break-words text-primary underline underline-offset-4">https://possentra.com</a>
                    </p>
                    <p>
                        <strong class="text-foreground">Contact:</strong>
                        <a href="mailto:peter@possentra.com" class="ml-2 break-words text-primary underline underline-offset-4">peter@possentra.com</a>
                    </p>
                </div>
            </div>
        </article>
    </section>
</template>